<template>
	<div v-if="body_show">
		<div class="header">
			<div class="text-center tutor-ico">
				<img :src="picture" alt="" />
			</div>
			<h2>{{name}}</h2>
			<h3>您的反馈对我们很重要，请对本次辅导进行点评！</h3>
		</div>
		<div class="succ_bottom">
			<div class="succ_ty clearfix">
				<div class="su_l flex-text">辅导满意度：</div>
				<van-rate class="flex-item" @change="lockState('lock1')" color="#EB5032" v-model="rateVal1" />
				<div class="su_num flex-text text-red">{{rateVal1}}分</div>
			</div>
			<div class="succ_ty clearfix">
				<div class="su_l flex-text">问题解决度：</div>
				<van-rate class="flex-item" @change="lockState('lock2')" color="#EB5032" v-model="rateVal2" />
				<div class="su_num flex-text text-red">{{rateVal2}}分</div>
			</div>
		</div>
		<div class="ts">
			<textarea v-model="pj_value" class="pj_textar" placeholder="授人玫瑰，手留余香! 请在此给咨询师走心的点评"></textarea>
		</div>
		<div class="consent_bottom">
			<a @click="submitData" :class="[lock1 && lock2 ? 'xz' : '', 'next']">提交</a>
		</div>
		<van-popup class="explain" v-model="showModul">
      <div>
        <h1 class="clearfix">
        	<img src="@a/close.png" @click="showModul = false"/>
      	</h1>
				<img src="../../../assets/pr1.png" class="tas_img" />
				<p>非常感谢您的评价！<br/>我们是人才加速器，永远关注和支持您的发展！</p>
				<!-- <a href="../index.html" class="tas_href">去首页</a> -->
				<router-link to="/index" class="tas_href">去首页</router-link>
      </div>
    </van-popup>
	</div>
</template>
<script>
	import { feebackteacher, feedback } from '@/api/totoring'
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				showModul: false,
				body_show: false,
				rateVal1: 0,
				rateVal2: 0,
				//
				radio_check1: null,
				pj_value: null,
				teacherid: '',
				name: '',
				picture: '',
				//
				lock1: false,
				lock2: false
			}
		},
		methods: {
			lockState(key){
				this[key] = true;
			},
			pullData(){
				let q = this.$route.query;
				feebackteacher({
					pay: q.pay,
					teacherid: q.teacherid
				})
				.then((data) => {
					shareCon("totoring", this);
					this.teacherid = data.teacherid;
					this.name = data.name;
					this.picture = data.picture;
					this.body_show = true;
				})
			},
			submitData(){
				if(this.lock1 && this.lock2){
					feedback({
						teacherid: this.teacherid,
						satisfaction: this.rateVal1,
						solve: this.rateVal2,
						remark: this.pj_value
					})
					.then((data) => {
						if(data.code){
							this.$dialog.alert({
							  title: '温馨提示',
							  message: data.msg
							}).then(() => {});
						}else{
							this.showModul = true;
						}

					})
				}
			}
		},
		created(){
			this.pullData();
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.text-red{
		color: #EB5032;
	}
	.header{
    padding: changeRem(1.2)+px 0;
    border-bottom: 1px solid #ccc;
    background: #fff;
    text-align: center;
    *{
    	font-weight: normal;
    }
    h2{
    	color: #333;
	    font-size: changeRem(0.68)+px;
	    margin-top: changeRem(0.4)+px;
    }
    h3{
    	color: #333;
	    font-size: changeRem(0.52)+px;
	    margin-top: changeRem(0.6)+px;
    }
    .tutor-ico{
    	img{
		    width: changeRem(2.4)+px;
		    height: changeRem(2.4)+px;
		    vertical-align: middle;
		    border-radius: 50%;
    	}
    }
	}
	.succ_bottom{
		padding: changeRem(0.92)+px changeRem(0.6)+px;
    background: #fff;
    border-bottom: 1px solid #ccc;
		.succ_ty{
			display: flex;
			justify-content: space-between;
		}
		.flex-text{
			// line-height: 46px;
			height: changeRem(1.05)+px;
			line-height: changeRem(1.05)+px;
		}
	}
	.flex-item{
		.van-rate__item{
			margin: 0 10px;
		}
	}
	.ts{
		padding-bottom: changeRem(0.8)+px;
    background: #fff;
    padding-top: changeRem(0.4)+px;
    .pj_textar{
    	font-size: changeRem(0.52)+px;
	    line-height: changeRem(0.8)+px;
	    color: #333;
	    padding: 0 changeRem(0.6)+px;
	    height: changeRem(7.4)+px;
	    margin-bottom: 0;
	    border: none;
	    display: block;
	    width: 100%;
    }
	}
	.consent_bottom{
    position: fixed;
    bottom: 0;
    height: changeRem(2.4)+px;
    padding-top: changeRem(0.6)+px;
    background: #fff;
    width: 100%;
    .next{
    	display: block;
    	width: changeRem(3.48)+px;
	    height: changeRem(1.32)+px;
	    line-height: changeRem(1.32)+px;
	    background: rgba(204, 204, 204, 1);
	    border-radius: changeRem(0.66)+px;
	    margin: 0 auto;
	    color: #fff;
	    font-size: changeRem(0.68)+px;
	    text-align: center;
    }
    .xz{
    	background-color: #EB5032;
    }
	}
  .explain{
    width: 9rem;
    height: auto;
    border-radius: changeRem(0.16)+px;
    background: #fff;
    text-align: center;
    padding: changeRem(0.8)+px changeRem(0.8)+px;
    img{
    	max-width: 100%;
    }
    h1{
    	img{
		    float: right;
  			width: changeRem(0.48)+px;
    	}
    }
    p{
	    font-size: changeRem(0.56)+px;
	    color: #666;
	    margin-top: changeRem(0.92)+px;
    }
    .tas_href{
    	display: block;
	    margin: 0 auto;
	    margin-top: changeRem(1.4)+px;
	    width: changeRem(7.7)+px;
	    height: changeRem(1.6)+px;
	    line-height: changeRem(1.6)+px;
	    background: rgba(235, 80, 50, 1);
	    border-radius: changeRem(0.16)+px;
	    color: #fff;
	    font-size: changeRem(0.68)+px;
    }
  }
</style>